export default function getCompositionHash(composition) {
  return composition?.join(',') || ''
}
